import { createAction } from '@ngrx/store';

export const initializeHttpRoutingList = createAction(
  '[@zerops/zerops/features/http-routing-list] list-initilized',
  (projectId: string) => ({ projectId })
);
